import { REQUEST_PARAMS } from "@/constants";
import { SearchParams } from "@/types";
import { useSearchParams } from "next/navigation";

export const usePathWithParams = () => {
  const sp = useSearchParams();
  const params: SearchParams = {};
  if (sp.get(REQUEST_PARAMS.size)) {
    params.size = sp.get(REQUEST_PARAMS.size) ?? undefined;
  }
  if (sp.get(REQUEST_PARAMS.date_from)) {
    params.date_from = sp.get(REQUEST_PARAMS.date_from) ?? undefined;
  }
  if (sp.get(REQUEST_PARAMS.date_to)) {
    params.date_to = sp.get(REQUEST_PARAMS.date_to) ?? undefined;
  }

  const pathWithParams = (path: string) => {
    return `${path}?${new URLSearchParams(params as Record<string, string>).toString()}`;
  };
  return pathWithParams;
};